 export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    let productForm = document.querySelector('.js-single-product-form');
    if (productForm) {
      let data_product = productForm.dataset.product;
      productForm.querySelector('.Form__Field--Object').value = data_product;
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-product.js